import { registerPlugin } from '@capacitor/core'

export interface FacebookLoginPlugin {
  login(config: { permissions: string[] }): Promise<FacebookLoginResponse>
  logout(): Promise<void>
}

export interface FacebookLoginResponse {
  accessToken?: {
    token: string
  }
}

export const FacebookLogin =
  registerPlugin<FacebookLoginPlugin>('FacebookLogin')
